export default "__VITE_ASSET__CCsGLxhX__"